import { reactive, provide, toRefs, inject } from "@vue/composition-api";
import appStoreDialogActions from "@/store/modules/AppStoreDialog/appStoreDialogActions";
import appStoreDialogGetters from "@/store/modules/AppStoreDialog/appStoreDialogGetters";
import appStoreDialogFlags from "@/store/modules/AppStoreDialog/appStoreDialogFlags";

export const state = reactive({
    appData: {},
    upgradeBundle: {},
    currentTab: 'overview',
    currentTabOptions: {},
    footerActions: [],
    tabs: [],
    onUpdate: null
});


export const actions = appStoreDialogActions();
export const flags = appStoreDialogFlags()
export const getters = appStoreDialogGetters();

export const key = Symbol("AppStoreModalDialog");

export const provideAppStoreDialog = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions,
        flags,
        appStoreDialogFlags: flags,
        appStoreDialogGetters: getters,
        appStoreDialogActions: actions,
        appStoreDialogState: state
    });
};

export default () => inject(key);
